import React from 'react';
import '../shared.css';
import Sidebar from '../Components/Layout/sidebar';
import Topbar from '../Components/Layout/topbar';

const UsersRoles = () => (
  <main>
    <Sidebar />
    <div className='pagestrcutre'>
      <Topbar />

      <div className='page_content' style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        flex: 1, paddingBottom: 60,
      }}>
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          gap: 20, maxWidth: 480, textAlign: 'center',
        }}>
          {/* Lock icon */}
          <div style={{
            width: 80, height: 80, borderRadius: '50%',
            background: 'rgba(214,184,147,0.3)', border: '2px solid rgba(214,184,147,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            animation: 'pulse 2.5s ease-in-out infinite',
          }}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
              <rect x="5" y="11" width="14" height="10" rx="2" stroke="#D6B893" strokeWidth="1.6"/>
              <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#D6B893" strokeWidth="1.6" strokeLinecap="round"/>
              <circle cx="12" cy="16" r="1.5" fill="#D6B893"/>
            </svg>
          </div>

          <div>
            <h2 style={{
              fontFamily: '"Cormorant Garamond"', fontSize: 36, fontWeight: 600,
              color: '#0D0D0D', lineHeight: '42px',
            }}>Access Restricted</h2>
            <p style={{
              fontFamily: 'Inter', fontSize: 15, color: '#8B8B7A',
              lineHeight: '24px', marginTop: 10,
            }}>
              You don't have permission to view <strong style={{ color: '#191919' }}>Users & Roles</strong>.
              This section is reserved for Super Admins only.
            </p>
          </div>

          <div style={{
            background: 'rgba(214,184,147,0.25)', border: '1px solid rgba(214,184,147,0.4)',
            borderRadius: 10, padding: '16px 24px', width: '100%',
          }}>
            <p style={{ fontFamily: 'Inter', fontSize: 13, color: '#8B8B7A', lineHeight: '20px' }}>
              To gain access, contact your Super Admin or request elevated permissions through your organisation's admin portal.
            </p>
          </div>

          <button style={{
            background: '#0D0D0D', color: '#D6B893', border: 'none',
            borderRadius: 6, padding: '10px 28px', fontFamily: 'Inter',
            fontSize: 13, fontWeight: 500, cursor: 'pointer',
            transition: 'background 0.2s ease, transform 0.15s ease',
          }}
            onMouseEnter={e => { e.currentTarget.style.background = '#1a1a1a'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.background = '#0D0D0D'; e.currentTarget.style.transform = 'none'; }}
            onClick={() => window.history.back()}
          >← Go Back</button>
        </div>
      </div>
    </div>

    <style>{`
      @keyframes pulse {
        0%, 100% { box-shadow: 0 0 0 0 rgba(214,184,147,0.35); }
        50%       { box-shadow: 0 0 0 12px rgba(214,184,147,0); }
      }
    `}</style>
  </main>
);

export default UsersRoles;